angular.module('app.directives').directive('ngEnter', () =>
    (scope, elem, attrs) =>
    elem.bind('keydown keypress', function(event) {
        if (event.which === 13) {
            scope.$apply(() => scope.$eval(attrs.ngEnter, { event }));
            return event.preventDefault();
        }
    })

);


// WEBPACK FOOTER //
// ./directives/enter.js